export default "__VITE_PUBLIC_ASSET__4126b678__"